import {
  type AttributeFilter,
  type DateFilter,
  type Filter,
  type ToggleFilter,
} from '@kijiji/generated/graphql-types'

import {
  type DateRangeFilter,
  type RangeFilterMinMax,
  isDateFilter,
  isDateRangeFilter,
  isRangeFilterWithMinMax,
  isToggleFilter,
} from '@/types/search'

export const isFilterApplied = (filter: Filter) => {
  if (isRangeFilterWithMinMax(filter)) {
    return isRangeFilterMinMaxApplied(filter)
  } else if (isDateRangeFilter(filter)) {
    return isDateRangeFilterApplied(filter)
  } else if (isDateFilter(filter)) {
    return isDateFilterApplied(filter)
  } else if (isToggleFilter(filter)) {
    return isToggleFilterApplied(filter)
  } else {
    return isAttributeFilterApplied(filter)
  }
}

export const isRangeFilterMinMaxApplied = (filter: RangeFilterMinMax) => {
  const { selectedRangeValues } = filter

  return (
    selectedRangeValues !== null &&
    (selectedRangeValues?.min !== null || selectedRangeValues?.max !== null)
  )
}

export const isDateRangeFilterApplied = (filter: DateRangeFilter) => {
  const { selectedRangeValues } = filter
  return (
    selectedRangeValues !== null &&
    (selectedRangeValues?.start !== null || selectedRangeValues?.end !== null)
  )
}

export const isDateFilterApplied = (filter: DateFilter) => filter.selectedValue !== null

export const isToggleFilterApplied = (filter: ToggleFilter) => filter.isSelected

export const isAttributeFilterApplied = (filter: AttributeFilter) => {
  return (
    ('selectedValues' in filter &&
      filter.selectedValues &&
      filter.selectedValues.length > 0 &&
      filter.selectedValues?.[0] !== '0') ??
    false
  )
}
